import { css } from '@emotion/react'

export const title = css`
  line-height: 20px;
  font-style: italic;
`

export const header = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`

export const logo = css`
  width: 42px;
  height: 40px;
`

export const logoText = css`
  margin-left: 10px;
  font-size: 29px;
  line-height: 36px;
  letter-spacing: -0.03em;
  text-decoration: none;
  font-style: italic;
`

export const link = css`
  margin-bottom: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`
